

export const traslateHelper =(patnerName)=>{
    let newName =""
    switch (patnerName){
        case "Venéco":
            newName="Yielder West"
            break
        case "PHC tailored telecom":
            newName="Yielder South"
            break
        default:
            newName = patnerName
    }

    return newName
}

export const providerTranslateHelper =(provider)=>{
    let newName=""
    switch (provider){
        case "Venéco":
            newName="Yielder Mobile Go"
            break
        case "PHC":
            newName="Yielder Mobile Go"
            break
        case "Yielder":
            newName= "Yielder Mobile Flex"
            break
        default:
            newName = provider
    }

    return newName
}


export const providerTranslateHelperShort =(provider)=>{
    let newName=""
    switch (provider){
        case "Venéco":
            newName="YMG"
            break
        case "PHC":
            newName="YMG"
            break
        case "Yielder":
            newName= "YMF"
            break
        default:
            newName = provider
    }

    return newName
}



